import { htmlToPlainText } from '@repo/types'
import { useEmailAccounts } from '@/hooks/api/emails'
import type { EmailDraft } from './AssistantContext'

/**
 * Náhľad e-mailu na potvrdenie. Telo sa zobrazuje ako čistý text (bez innerHTML) —
 * návrh generuje LLM, obsah netreba renderovať ako HTML.
 */
export function EmailConfirmCard({
  pending,
  onRespond,
  disabled,
}: {
  pending: EmailDraft
  onRespond: (toolUseId: string, approved: boolean) => void
  disabled?: boolean
}) {
  const { draft } = pending
  const { data: accounts } = useEmailAccounts()
  const from = accounts?.find((acc) => acc.id === draft.accountId)?.emailAddress
  return (
    <div className="card space-y-2 p-3 text-sm">
      <p className="text-xs uppercase text-gray-500 dark:text-gray-400">Náhľad e-mailu</p>
      {from ? <p className="break-words text-gray-600 dark:text-gray-300">Od: {from}</p> : null}
      <p className="break-words text-gray-600 dark:text-gray-300">Komu: {draft.to.join(', ')}</p>
      {draft.cc?.length ? <p className="break-words text-gray-600 dark:text-gray-300">Kópia: {draft.cc.join(', ')}</p> : null}
      <p className="break-words font-semibold text-gray-900 dark:text-gray-100">{draft.subject}</p>
      <div className="max-h-48 overflow-y-auto whitespace-pre-wrap break-words rounded-lg bg-gray-50 p-2 text-gray-800 dark:bg-gray-900 dark:text-gray-200">
        {htmlToPlainText(draft.bodyHtml)}
      </div>
      <div className="flex gap-2 pt-1">
        <button type="button" className="btn-secondary flex-1 justify-center" disabled={disabled} onClick={() => onRespond(pending.toolUseId, false)}>
          Zrušiť
        </button>
        <button type="button" className="btn-primary flex-1 justify-center" disabled={disabled} onClick={() => onRespond(pending.toolUseId, true)}>
          Odoslať
        </button>
      </div>
    </div>
  )
}
